module.exports = __webpack_public_path__ + "static/media/8.434e0bd0.png";